export default __webpack_public_path__ + "static/banner3-2265c24faf9f617dbf49eca73a5236b3.jpg";